import {Injectable} from '@angular/core';
import {ApModalResult, ApModalService} from 'webcommon/core-ui';
import { ApFindControlModifyModalComponent } from './ap-findcontrol-modify-modal.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApFindControlModifyModalService{
  constructor(
    private apModalService: ApModalService,
  ) { }

  openModal(
    findControlBehaviorPk: string,
    findControlBehaviorName: string,
  ): Observable<ApModalResult<string>> {
    const initialState = {
      findControlBehaviorPk,
      findControlBehaviorName,
    };

    const p = this.apModalService.showComponentModal$(ApFindControlModifyModalComponent, {
      panelClass: 'emds-modal-medium',
      disableClose: true,
      initialState,
    });

    return p;
  }
}
